export { default as GoogleAnalyticsProvider } from './GoogleAnalyticsProvider';
export { default as withGoogleAnalytics } from './withGoogleAnalytics';
export { default as googleAnalyticsShape } from './googleAnalyticsShape';



// WEBPACK FOOTER //
// ./src/frontend/components/googleAnalytics/index.js